// extracted by mini-css-extract-plugin
export var card = "card-module--card--HgP+s";
export var image = "card-module--image--Te9ub";
export var text = "card-module--text--bmgF3";
export var wrapper = "card-module--wrapper--lGItR";